import { mapGetters } from 'vuex'

export default {
  mounted() {
    // Track pending route if exists - use nextTick to ensure store is ready
    this.$nextTick(() => {
      if (window.__pendingRouteTrack) {
        this.track('Page viewed', window.__pendingRouteTrack)
        delete window.__pendingRouteTrack
      }
    })
  },
  methods: {
    track(event, data) { // event.event: "Opened video"
      if(!event) return

      try {
        // Safely get user properties with fallbacks
        const trackingData = {
          distinct_id: this.user?.email || 'anonymous',
          mobile_app: this.isApp || false,
          current_team_name: this.currentTeam?.team_name || null,
          current_team_id: this.currentTeam?.id || null,
          team_orderer: this.isOrderer || false,
          team_admin: this.isAdmin || false,
          plan_id: this.currentPlanId || null,
          ...data
        }

        // Remove null/undefined values
        const cleanData = Object.fromEntries(
          Object.entries(trackingData).filter(([, value]) => value !== null && value !== undefined)
        )

        this.$mixpanel.track(event, cleanData)
      } catch (error) {
        console.warn('Tracking failed for event:', event, error)
      }
    }
  },
  computed: {
    ...mapGetters('user', [
      'user',
      'currentTeam',
      'current_sport_id',
      'isOrderer',
      'isAdmin',
      'plan_id'
    ]),
    isApp() {
      let standalone = window.navigator.standalone
      let userAgent = window.navigator.userAgent.toLowerCase()
      let safari = /safari/.test(userAgent)
      let ios = /iphone|ipod|ipad/.test(userAgent)

      if (ios) {
        if (!standalone && safari) {
          // Safari
          return false
        } else if (!standalone && !safari) {
          // iOS webview
          return true
        }
      } else {
        if (userAgent.includes('wv')) {
          return true
          // Android webview
        } else {
          return false
          // Chrome
        }
      }

      return false
    }
  }
}